import { render, staticRenderFns } from "./fastTaskByLaws.vue?vue&type=template&id=565ac1bb&scoped=true&"
import script from "./fastTaskByLaws.vue?vue&type=script&lang=js&"
export * from "./fastTaskByLaws.vue?vue&type=script&lang=js&"
import style0 from "./fastTaskByLaws.vue?vue&type=style&index=0&id=565ac1bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ac1bb",
  null
  
)

export default component.exports